/*
    userPermissions -> oidc from the server, can be string or array
    allowedPermission -> component permissions
*/
const isUserPermissionsInclude = userPermissions => {

    return allowedPermission => {

        if(!userPermissions || !allowedPermission) {
      
            return false;
        }

        return userPermissions.includes(allowedPermission);
    };
};

export { isUserPermissionsInclude };


// WEBPACK FOOTER //
// ./src/services/autorization/index.js